import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "quantity-component" }
const _hoisted_2 = { class: "body-text" }
const _hoisted_3 = { class: "quantity-component-controls" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "body-text-bold" }
const _hoisted_6 = ["disabled"]

import { ref, onMounted, useAttrs } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'QuantityComponent',
  props: /*@__PURE__*/_mergeModels({
    placeHolder: {}
  }, {
    "modelValue": {
  type: Number,
  default: 1,
  required: true,
},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const attrs = useAttrs();

const inputComponent = ref<HTMLInputElement | null>(null);



const val = _useModel(__props, "modelValue");

onMounted(() => {
  if (attrs['auto-focus']) {
    inputComponent.value?.focus();
  }
});

function handleChange(value: number) {
  const newValue = val.value + value;
  if (newValue >= 1 && newValue <= 99) {
    val.value += value;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.placeHolder), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        class: "quantity-component-controls-button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (handleChange(-1))),
        disabled: val.value <= 1
      }, [...(_cache[2] || (_cache[2] = [
        _createElementVNode("div", { class: "minus-icon" }, null, -1)
      ]))], 8, _hoisted_4),
      _createElementVNode("p", _hoisted_5, _toDisplayString(val.value), 1),
      _createElementVNode("button", {
        class: "quantity-component-controls-button",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (handleChange(1))),
        disabled: val.value >= 99
      }, [...(_cache[3] || (_cache[3] = [
        _createElementVNode("div", { class: "plus-icon" }, null, -1)
      ]))], 8, _hoisted_6)
    ])
  ]))
}
}

})